import axios from 'axios';

export function getListCountry(payload) {
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/common/getallcountries',
        withCredentials: true,
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + payload,
        }
    }

    return axios(options)
}



// WEBPACK FOOTER //
// ./src/utils/getListCountry.js